export default __webpack_public_path__ + "static/media/an-quy-16170973985377.0f48c2b5.png";